<template>
  <div class="quick-filter">
    <b-form class="select_QuickFilter">
      <div id="cod-cliente-group" class="mt-1 mb-1 d-flex">
        <PFormSelect
          v-model="clienteSelected"
          :options="clientes"
          optionValue="id"
          optionText="codDesCliente"
          :label="$t('label.cliente')"
          :placeholder="$t('option.select')"
          variant="withoutBox"
          :disabled="!admin"
        />
      </div>
    </b-form>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ICliente, IClienteAll } from "@/entities";
import { IDocumentacionParams } from "@/services";
import { todosCliente } from "@/constans";

@Component({
  name: "quick-filter",
})
export default class QuickFilter extends Vue {
  @Prop() public params!: IDocumentacionParams;
  @Prop({ required: false, default: false }) public showOptionTodos!: boolean;
  @Prop({ required: false, default: "" }) public documentType!: string;
  @Action("setClienteSelected") setClienteSelected!: (cliente?: ICliente) => Promise<void>;

  @Getter("getClientesAll") getClientesAll!: IClienteAll[];
  @Getter("getClienteSelected") getClienteSelected!: ICliente;

  public admin = false;
  private optionTodos = todosCliente;

  get clienteSelected(): number {
    const cliente = this.getClienteSelected;
    return (
      cliente?.id ??
      this.clientes.find((c) => c.codCliente === this.params.codCliente)?.id ??
      this.clientes.find((c) => c.id?.toString() === this.params.pkCliente)?.id ??
      this.optionTodos.id!
    );
  }

  set clienteSelected(clienteId: number) {
    if (clienteId && clienteId !== this.optionTodos.id) {
      this.setClienteSelected(this.getCliente(clienteId)).then(() => {
        return this.onChangeCliente(this.clienteSelected);
      });
    } else {
      this.setClienteSelected().then(() => {
        if (this.showOptionTodos) {
          this.onChangeCliente();
        }
      });
    }
  }

  get clientes(): ICliente[] {
    let clientes = Object.assign([], this.getClientesAll);
    if (clientes.length > 1 && this.showOptionTodos) {
      clientes.unshift(this.optionTodos);
    }

    return clientes;
  }

  getCliente(clienteId: number): ICliente {
    return this.clientes.find((cliente) => cliente.id === clienteId) as ICliente;
  }

  async mounted(): Promise<void> {
    this.admin = this.clientes.length > 1;

    if (!this.getClienteSelected) {
      if (this.params.codCliente || this.params.pkCliente) {
        const clienteAll = this.clientes.find(
          (cliente) =>
            cliente.codCliente === this.params.codCliente ||
            cliente.id?.toString() === this.params.pkCliente
        );
        if (clienteAll && clienteAll.id !== this.optionTodos.id) {
          await this.setClienteSelected(clienteAll as ICliente);
        } else {
          await this.loadFirstCliente();
        }
      } else {
        await this.loadFirstCliente();
      }

      if (!this.showOptionTodos) {
        this.$emit("change", this.params);
      }
    }
  }

  async loadFirstCliente(): Promise<void> {
    const cliente = this.clientes[0] as ICliente;
    if (cliente.id !== this.optionTodos.id) {
      await this.setClienteSelected(cliente);
    } else {
      await this.setClienteSelected();
    }
  }

  async onChangeCliente(clienteId?: number): Promise<void> {
    if (clienteId && clienteId !== -1) {
      if (this.documentType == "ByImportacion" || this.documentType == "ByNonHistorical") {
        this.params.pkCliente = clienteId.toString();
      } else {
        this.params.codCliente = this.getClienteSelected.codCliente;
      }
    }
    this.$emit("change", this.params);
  }
}
</script>

<style lang="scss" scoped>
.material::v-deep .vs__dropdown-toggle {
  border: none;
  cursor: pointer;
}

.material::v-deep .vs__selected-options .vs__selected {
  padding-left: 0;
  margin-top: 0;
  margin-left: 0;
  font-size: 14px;
  color: #808080;
  font-weight: bold;
}

#input-cod-cliente-button {
  width: 150px;
  font-size: 12px;
  padding: 0;
  color: #979797;
  text-align: start;
}

#input-cod-cliente-icon {
  margin-left: 8px;
}

#input-cod-cliente {
  width: 150px;
}

.separator {
  width: 1px;
  height: 100%;
  border: solid 1px #e9e9e9;
}

#divisas-group {
  padding: 0 2em;
}

#input-divisas-label {
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
}

#divisas-group > button {
  margin-right: 10px;
  width: 68px;
  height: 23px;
  object-fit: contain;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding-top: 0.15rem;
  padding-left: 16px;
  padding-right: 16px;
  color: var(--secundario-prosegur-oscuro);
  background-color: var(--fondo-not-active-toggle);
  border-color: var(--fondo-not-active-toggle);
}

#divisas-group > button.active {
  font-weight: 500;
  background-color: var(--amarillo-prosegur);
  border-color: var(--amarillo-prosegur);
}

.select_QuickFilter {
  display: flex !important;
  flex-direction: column;
}
</style>
